import { render, staticRenderFns } from "./CommercialBillOfLadingFinishedGoodForm.vue?vue&type=template&id=60f6173d&scoped=true&"
import script from "./CommercialBillOfLadingFinishedGoodForm.vue?vue&type=script&lang=js&"
export * from "./CommercialBillOfLadingFinishedGoodForm.vue?vue&type=script&lang=js&"
import style0 from "./CommercialBillOfLadingFinishedGoodForm.vue?vue&type=style&index=0&id=60f6173d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6173d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VChip,VCol,VDataTable,VRow,VTooltip})
